/* Trade enquiry list: independent of sale inventory, no checkout and no cart
   mutation. Store product selections only, scoped to customer/company location. */
(() => {
  if (window.DRTradeEnquiry) return;
  const source = document.querySelector('[data-dr-enquiry-config]');
  if (!source) return;
  const config = JSON.parse(source.textContent);
  const active = config.enabled || !!document.querySelector('[data-dr-enquiry-summary]');
  if (!active) return;
  const key = 'dr:trade-enquiry:v1:' + config.scope;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const safeUrl = (value, image = false) => {
    try {
      const url = new URL(value, location.origin);
      if (url.protocol !== 'https:') return '';
      if (!image && (url.origin !== location.origin || !url.pathname.includes('/products/'))) return '';
      return url.href;
    } catch (_) { return ''; }
  };
  const quantity = n => Math.min(999, Math.max(0, Math.floor(Number(n) || 0)));
  function normalize(item) {
    if (!item || !item.productId || !item.title || !safeUrl(item.url)) return null;
    const properties = Object.fromEntries(Object.entries(item.properties || {}).filter(([k, v]) => !k.startsWith('_') && v != null && String(v).trim()).map(([k, v]) => [k, String(v)]));
    const line = {
      productId: item.productId, variantId: item.variantId || null,
      title: String(item.title), vendor: String(item.vendor || ''),
      url: safeUrl(item.url), image: item.image ? safeUrl(item.image, true) : '',
      selection: String(item.selection || ''), properties,
      price: Number.isFinite(item.price) && item.price >= 0 ? item.price : null,
      quantity: quantity(item.quantity)
    };
    line.key = JSON.stringify([line.productId, line.variantId, line.selection, Object.entries(properties).sort()]);
    return line.quantity ? line : null;
  }
  function read() {
    const stored = localStorage.getItem(key);
    const raw = stored === null ? config.items : JSON.parse(stored);
    if (!Array.isArray(raw)) throw new Error('Invalid saved enquiry list');
    return raw.map(normalize).filter(Boolean);
  }
  let items;
  try { items = read(); } catch (_) { items = (config.items || []).map(normalize).filter(Boolean); }
  const count = () => items.reduce((n, item) => n + item.quantity, 0);
  const money = cents => new Intl.NumberFormat('en-AU', { style: 'currency', currency: config.currency || 'AUD', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100) + (window.DRPriceCurrency?.enabled ? ' ' + (config.currency || window.DRPriceCurrency.code) : '');
  function details(item) {
    const custom = item.properties['Custom Size'];
    return [!custom && item.selection !== 'Default Title' ? item.selection : '',
      ...Object.entries(item.properties).map(([name, value]) => name + ': ' + value)].filter(Boolean);
  }
  function lineHTML(item, editable) {
    const controls = editable
      ? `<div class="cart-line__qty"><button type="button" class="cart-line__qty-btn" data-enquiry-key="${esc(item.key)}" data-enquiry-qty="${item.quantity - 1}" aria-label="Decrease quantity for ${esc(item.title)}">−</button><span class="cart-line__qty-value">${item.quantity}</span><button type="button" class="cart-line__qty-btn" data-enquiry-key="${esc(item.key)}" data-enquiry-qty="${item.quantity + 1}" aria-label="Increase quantity for ${esc(item.title)}">+</button></div>`
      : `<span class="cart-line__qty-value">Quantity: ${item.quantity}</span>`;
    return `<div class="cart-line"><div class="cart-line__media">${item.image ? `<img src="${esc(item.image)}" alt="${esc(item.title)}" width="160" height="160" loading="lazy">` : ''}</div><div class="cart-line__info"><p class="cart-line__vendor">${esc(item.vendor)}</p><a class="cart-line__title" href="${esc(item.url)}">${esc(item.title)}</a>${details(item).map(value => `<p class="cart-line__option">${esc(value)}</p>`).join('')}<div class="cart-line__row">${controls}${item.price !== null && !item.properties['Custom Size'] ? `<span class="cart-line__price">${esc(money(item.price * item.quantity))}</span>` : ''}</div>${editable ? `<button type="button" class="cart-line__remove link-quiet" data-enquiry-key="${esc(item.key)}" data-enquiry-qty="0" aria-label="Remove ${esc(item.title)}">Remove</button>` : ''}</div></div>`;
  }
  function listHTML(kind, editable) {
    if (!items.length) return `<div class="${kind}__empty"><p>${esc(config.empty)}</p><a class="btn" href="${esc(config.browseUrl)}">${esc(config.continue)}</a></div>`;
    return `<ul class="${kind}__items" role="list">${items.map(item => `<li class="${kind}__item">${lineHTML(item, editable)}</li>`).join('')}</ul>`;
  }
  function footerHTML(drawer) {
    if (!items.length) return '';
    return `<div class="${drawer ? 'cart-drawer' : 'cart-page'}__foot"><p class="cart-drawer__note">${esc(config.note)}</p>${drawer ? `<button type="button" class="btn cart-continue" data-cart-close>${esc(config.continue)}</button>` : `<a class="btn" href="${esc(config.browseUrl)}">${esc(config.continue)}</a>`}<a class="btn btn--primary cart-drawer__checkout" href="${esc(config.sendUrl)}">${esc(config.send)}</a>${drawer ? `<a class="cart-drawer__view-cart link-quiet" href="${esc(config.listUrl)}">${esc(config.view)}</a>` : ''}</div>`;
  }
  function renderDrawer() {
    const drawer = document.querySelector('cart-drawer');
    const dialog = drawer?.querySelector('#CartDrawer');
    if (!dialog) return;
    const body = dialog.querySelector('[data-cart-body]');
    const title = dialog.querySelector('[data-cart-title]');
    title.textContent = config.title;
    dialog.setAttribute('aria-label', config.title);
    body.innerHTML = listHTML('cart-drawer', true);
    dialog.querySelector('.cart-drawer__foot')?.remove();
    body.insertAdjacentHTML('afterend', footerHTML(true));
    drawer.syncCount?.(count());
    document.querySelectorAll('[data-cart-count-label]').forEach(el => { el.textContent = config.title + ', ' + count() + ' items'; });
  }
  function syncForm() {
    const wrapper = document.querySelector('[data-form-id="trade-enquiry-list"]');
    if (!wrapper) return;
    const payload = items.map(item => [item.title, ...details(item), 'qty ' + item.quantity, item.url].join(' — ')).join(' • ');
    window.DRAppForms?.update(wrapper, { hidden: { count: count(), list: payload } });
    wrapper.querySelectorAll('button.submit,button[type=submit]').forEach(button => {
      if (!items.length && !button.disabled) {
        button.dataset.drEmptyListDisabled = 'true';
        button.disabled = true;
      } else if (items.length && button.dataset.drEmptyListDisabled) {
        delete button.dataset.drEmptyListDisabled;
        button.disabled = false;
      }
      // Never re-enable a non-empty form the vendor disabled while sending.
    });
    wrapper.dataset.enquiryCount = String(count());
  }
  function render() {
    renderDrawer();
    const page = document.querySelector('[data-dr-enquiry-page]');
    if (page) page.innerHTML = listHTML('cart-page', true) + footerHTML(false);
    const summary = document.querySelector('[data-dr-enquiry-summary]');
    if (summary) summary.innerHTML = listHTML('enq-send', false) + (items.length ? `<p class="enq-send__note">${esc(config.note)}</p><p class="enq-send__edit"><a class="link-quiet" href="${esc(config.listUrl)}">${esc(config.view)}</a></p>` : '');
    syncForm();
  }
  function save(next) {
    // Do not report a successful add unless it will survive page navigation.
    localStorage.setItem(key, JSON.stringify(next));
    items = next;
    render();
    document.dispatchEvent(new CustomEvent('enquiry:change', { detail: { item_count: count() } }));
  }
  window.DRTradeEnquiry = {
    active: true, renderDrawer,
    add(item) {
      const line = normalize(item);
      if (!line) throw new Error('Invalid enquiry selection');
      const next = items.map(item => ({ ...item }));
      const existing = next.find(item => item.key === line.key);
      if (existing) existing.quantity = quantity(existing.quantity + line.quantity);
      else next.push(line);
      save(next);
    },
    snapshot: () => JSON.parse(JSON.stringify(items))
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-enquiry-qty]');
    if (!button) return;
    const rowKey = button.dataset.enquiryKey;
    const qty = quantity(button.dataset.enquiryQty);
    const inDrawer = !!button.closest('cart-drawer');
    try {
      save(items.map(item => item.key === rowKey ? { ...item, quantity: qty } : item).filter(item => item.quantity));
      // Re-rendered controls are new nodes: retain keyboard focus and the trap.
      if (inDrawer) {
        const dialog = document.querySelector('#CartDrawer');
        const replacement = [...dialog.querySelectorAll('[data-enquiry-qty]')].find(e => e.dataset.enquiryKey === rowKey);
        window.trapFocus?.(dialog, replacement || dialog.querySelector('[data-cart-close]'));
      }
    } catch (_) {
      const live = document.querySelector('[data-cart-live]');
      if (live) live.textContent = 'Your enquiry could not be saved. Please allow browser storage and try again.';
    }
  });
  document.addEventListener('submit', event => {
    if (!event.target.closest('[data-form-id="trade-enquiry-list"]')) return;
    syncForm();
    if (!items.length) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  window.addEventListener('storage', event => { if (event.key === key) { try { items = read(); render(); } catch (_) {} } });
  window.addEventListener('pageshow', () => { try { items = read(); render(); } catch (_) {} });
  document.addEventListener('globo.formbuilder.form.loaded', syncForm);
  document.addEventListener('globo.formbuilder.form.success', syncForm);
  render();
  // The form app can hydrate after theme defer scripts; update only the hidden
  // payload and disabled state, never re-render customer-entered form controls.
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; syncForm(); });
  }).observe(document.querySelector('[data-form-id="trade-enquiry-list"]') || source, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
})();
